import React, { useState, useEffect } from 'react';
import MainLayout from '../user-dashboard/MainLayout';

export default function ContactPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#F8F9FA',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <MainLayout>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          padding: isMobile ? '40px 20px' : '64px 40px'
        }}>
          {/* Header */}
          <div style={{ marginBottom: '48px' }}>
            <h1 style={{
              fontSize: isMobile ? '32px' : '48px',
              fontWeight: '600',
              color: '#1B365D',
              margin: '0 0 12px 0',
              letterSpacing: '-1px',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }}>
              Contact Us
            </h1>
            <p style={{
              fontSize: '16px',
              color: '#6B7280',
              margin: 0,
              lineHeight: '1.5'
            }}>
              For any questions about the Face Forward Web program, please reach out to us:
            </p>
          </div>

          {/* Contact Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: '24px'
          }}>
            {/* Email Card */}
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '16px',
              padding: '40px 32px',
              border: '1px solid #E5E7EB',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              textAlign: 'center'
            }}>
              <div style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                backgroundColor: '#3B82F6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <svg width="28" height="28" fill="#FFFFFF" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </div>
              <h3 style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 16px 0',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }}>
                Email
              </h3>
              <a
                href="mailto:mghfacialpainstudy@mgb.org"
                style={{
                  fontSize: '16px',
                  color: '#3B82F6',
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                mghfacialpainstudy@mgb.org
              </a>
            </div>

            {/* Phone Card */}
            <div style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '16px',
              padding: '40px 32px',
              border: '1px solid #E5E7EB',
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
              textAlign: 'center'
            }}>
              <div style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                backgroundColor: '#10B981',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px'
              }}>
                <svg width="28" height="28" fill="#FFFFFF" viewBox="0 0 24 24">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
              </div>
              <h3 style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#374151',
                margin: '0 0 16px 0',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }}>
                Phone
              </h3>
              <a
                href="tel:6176438678"
                style={{
                  fontSize: '16px',
                  color: '#374151',
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
              >
                (617) 643-8678
              </a>
            </div>
          </div>
        </div>
      </MainLayout>
    </div>
  );
}